import * as React from 'react';
import styled from '@emotion/styled';

const StyledBanner = styled('div')`
  background-color: #fff3cd;
  color: #664d03;
  text-align: center;
  padding: 12px 16px;
  font-size: 0.9rem;

  a {
    color: #664d03;
    font-weight: bold;
    text-decoration: underline;
  }
`;

const DeprecationBanner = () => (
  <StyledBanner>
    Sentinel Hub Documentation is moving to a new home at{' '}
    <a href="https://docs.planet.com" target="_blank" rel="noopener noreferrer">
      docs.planet.com
    </a>
    . These docs will no longer be
    accessible.
  </StyledBanner>
);

export default DeprecationBanner;
